import { FlexContainer, IconWrapper, Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { SessionsProps } from './model';
import { SessionCard } from './Styles';

export const Sessions = ({
  iconName,
  count,
  description,
  gradient,
}: SessionsProps) => {
  const { t } = useTranslation();

  return (
    <SessionCard>
      <FlexContainer flexDirection="row" alignItems="center" columnGap="2.4">
        <IconWrapper size={'XL'} iconName={iconName} gradient={gradient} />
        <FlexContainer flexDirection="column" alignItems="start">
          <Label fontSize="32" color="pink400" semibold>
            {count}
          </Label>
          <Label fontSize="14" semibold>
            {t(description)}
          </Label>
        </FlexContainer>
      </FlexContainer>
    </SessionCard>
  );
};
